module.exports = __webpack_public_path__ + "img/daichao1.532435e5.png";